/* eslint-disable camelcase */
import { AxiosError } from 'axios';
import useSWRMutation, { TriggerWithArgs } from 'swr/mutation';

import { EmptyObjectT, WithStatusT } from '@consumer-frontend/nc-utils';

import {
  apiEndpoints,
  dashboardFetchers,
} from '../lib';

type SubmitCashAdvanceReqDataT = {
  disbursedAmount: number;
  displayedBankAccountNumber: string;
  displayedBankRoutingNumber: string;
  displayedExpectedFundingDate: string;
  drawFee: number;
  requestedAmount: number;
};

type SubmitCashAdvancePostDataT = {
  disbursed_amount: number;
  displayed_bank_account_number: string;
  displayed_bank_routing_number: string;
  displayed_expected_funding_date: string;
  draw_fee: number;
  requested_amount: number;
};

export type UseSubmitCashAdvanceRespT = {
  isMutating: boolean;
  trigger: TriggerWithArgs<
    WithStatusT<EmptyObjectT>,
    AxiosError,
    string,
    SubmitCashAdvanceReqDataT
  >
;
  status?: number;
};

export const useSubmitCashAdvance = (): UseSubmitCashAdvanceRespT => {
  const {
    data,
    error,
    trigger,
    isMutating,
  } = useSWRMutation<
    WithStatusT<EmptyObjectT>,
    AxiosError,
    string,
    SubmitCashAdvanceReqDataT
  >(
    apiEndpoints.dashboard.submitCashAdvance(),
    (url, { arg }) => dashboardFetchers.post<SubmitCashAdvancePostDataT, EmptyObjectT>(url, {
      arg: {
        disbursed_amount: arg.disbursedAmount,
        displayed_bank_account_number: arg.displayedBankAccountNumber,
        displayed_bank_routing_number: arg.displayedBankRoutingNumber,
        displayed_expected_funding_date: arg.displayedExpectedFundingDate,
        draw_fee: arg.drawFee,
        requested_amount: arg.requestedAmount,
      },
    }),
  );

  return {
    isMutating,
    status: error?.status || data?.status,
    trigger,
  };
};
